import { THUMBNAIL_VIEWPORT_H_OG, THUMBNAIL_VIEWPORT_W } from '@/lib/pages/thumbnail-capture';

// Hard cap on the OG-prep phase (capture + upload). If we exceed this, the
// publish proceeds without the captured PNG and the backend uses the
// generic server-rendered fallback. Per design §6.1: capture is non-blocking.
export const OG_PREP_TIMEOUT_MS = 10_000;

// Source-iframe dimensions for the OG capture. The capture *output* is
// 1200×630 (the OG spec canvas — that's the canvasWidth/canvasHeight
// passed to html-to-image inside `captureOgImage`), but the source
// iframe needs to be at the desktop viewport width so the page lays out
// the way it would on desktop, with the height matching the OG aspect
// ratio so html-to-image's stretch-to-canvas doesn't distort.
// 1280 / 1.905 ≈ 672 → THUMBNAIL_VIEWPORT_H_OG.
export const OG_VIRTUAL_W = THUMBNAIL_VIEWPORT_W;
export const OG_VIRTUAL_H = THUMBNAIL_VIEWPORT_H_OG;
